import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted-foreground col-span-full py-8 text-center text-xs"
}
const _hoisted_4 = { class: "font-bold" }

import { CreditCard } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { computed, ref } from 'vue';
    import InputError from '@/components/InputError.vue';
    import SearchInput from '@/components/SearchInput.vue';
    import VoucherAdministrateCardFormItem from './VoucherAdministrateCardFormItem.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAdministrateCardsForm',
  props: {
    form: {},
    employeeOptions: {},
    userOptions: {},
    isLoadingUserOptions: { type: Boolean }
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const searchTerm = ref('');

    const filteredCards = computed(() => {
        if (!searchTerm.value) {
            return props.form.cards;
        }

        return props.form.cards.filter(
            (card: CreditCard) =>
                card.name?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                card.number?.toLowerCase().includes(searchTerm.value.toLowerCase()),
        );
    });

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchInput, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      placeholder: _unref(t)('vouchers.administrate.search'),
      class: "w-full"
    }, null, 8, ["modelValue", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputError, {
        message: _ctx.form.errors.cards
      }, null, 8, ["message"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCards.value, (card, index) => {
        return (_openBlock(), _createBlock(VoucherAdministrateCardFormItem, {
          key: card.id,
          form: card,
          "main-form": _ctx.form,
          index: index,
          "employee-options": _ctx.employeeOptions,
          "user-options": _ctx.userOptions,
          "is-loading-user-options": _ctx.isLoadingUserOptions
        }, null, 8, ["form", "main-form", "index", "employee-options", "user-options", "is-loading-user-options"]))
      }), 128)),
      (filteredCards.value.length === 0 && _ctx.form.cards.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_i18n_t, {
              keypath: "forms.no_results",
              tag: "span",
              scope: "global"
            }, {
              term: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(searchTerm.value), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})